import { FC, } from 'react';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';
import { Bucket, bucketMappingDomain } from '@/common/enums/qiniu';

/**
 * 模仿动态表单的upload组件
 * @Description
 *  src/common/components/business/DynamicComponent/components/Upload.tsx
 */
const MeituanReport: FC<{
  propertyItem: any;
  disabled?: boolean;
  required?: boolean;
}> = ({
  propertyItem, // 美团property
  disabled = false,
  required = true,
}) => {
  const label = propertyItem.anotherName || propertyItem.name || '';

  const restriction = propertyItem.restriction ? JSON.parse(propertyItem.restriction) : {};

  const placeholder = restriction.placeholder ? restriction.placeholder : `请上传${label || ''}`;
  const extraTips = restriction.extraTips || ''; // 提示语
  const rules = [
    { required, message: placeholder },
  ];

  const acceptFile = restriction.accept?.some(val => ['.ppt', '.pptx', '.pdf', 'ppt', 'pptx', 'pdf', 'dwg', '.dwg'].includes(val));
  const acceptVideo = restriction.accept?.some(val => ['.mp4', '.3gp', '.m3u8', '.mov', '.avi', 'mp4', '3gp', 'm3u8', 'mov', 'avi'].includes(val));

  // 决定上传类型，文件/视频/图片
  const uploadType = acceptFile ? 'file' : acceptVideo ? 'video' : 'image';
  // 产品甜瓜让拿掉仅一个的限制，如果性能和视频流量又问题，用户自己承担
  // const uploadType = acceptFile ? 'file' : acceptVideo ? (restriction.maxCount > 1 ? 'file' : 'video') : 'image';

  // 内部组件能通过格式检查的后缀，注意需要将接口返回的类型去掉前缀点'.' ex ['.mov', '.mp4'] => ['mov','mp4']
  const fileType = Array.isArray(restriction.accept) && restriction.accept.length ? restriction.accept.map(itm => (itm && itm.substring(0, 1) === '.') ? itm.substring(1, itm.length) : itm
  ) : undefined;

  let qiniuParams: any = {};
  if (uploadType === 'file') {
    qiniuParams = {
      domain: bucketMappingDomain['linhuiba-file'],
      bucket: Bucket.File,
    };
  } else if (uploadType === 'video') {
    qiniuParams = {
      domain: bucketMappingDomain['linhuiba-video'],
      bucket: Bucket.Video,
    };
  } else if (uploadType === 'image') {
    qiniuParams = {
      domain: bucketMappingDomain['linhuiba-certs'],
      bucket: Bucket.Certs,
    };
  }

  return (
    <V2FormUpload
      label={label}
      name={propertyItem.identification}
      uploadType={uploadType}
      breakTheNorm={uploadType === 'video'}
      verticalMiddleHelp={extraTips
        ? <div className='fs-12 c-999 mb-8'>
          {extraTips}
        </div> : <></>}
      config={{
        qiniuParams,
        size: restriction.size,
        maxCount: restriction.maxCount,
        fileType,
        accept: Array.isArray(restriction.accept) ? restriction.accept : undefined,
        disabled,
        onRemove: disabled ? () => false : undefined
      }}
      rules={rules}
      required
    />
  );
};
export default MeituanReport;
